module.exports = __webpack_public_path__ + "img/arrow-u-up-left.caef68e5.svg";